var _title, _title2, _title3, _title4, _title5, _title6, _title7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardStatusChargedback = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "190.351 208.973 230.271 160.541",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: -251.192,
    y1: 236.904,
    x2: -251.192,
    y2: 288.039,
    id: "gradient-0",
    gradientTransform: "matrix(-0.579857, -0.814718, 0.616757, -0.438963, -535.698456, 171.789763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgba(181, 129, 8, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(84, 60, 4, 1)"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 190.351,
    y: 208.973,
    width: 230.271,
    height: 160.541,
    rx: 2,
    ry: 2,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, 526.00293, -143.878769)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Card")), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.22)"
    },
    x: -331.513,
    y: 381.082,
    width: 202.092,
    height: 128.911,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      fill: "rgb(236, 92, 12)",
      stroke: "rgb(175, 88, 17)"
    },
    x: -323.666,
    y: 374.082,
    width: 202.092,
    height: 128.911,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    x: -320.505,
    y: 399.616,
    width: 195.51,
    height: 27.321
  }), /*#__PURE__*/React.createElement("rect", {
    x: -306.89,
    y: 457.481,
    width: 63.758,
    height: 23.803,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(241, 180, 147)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -224.125 463.301 L -161.852 463.291"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      strokeWidth: 8,
      strokeLinecap: "round",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -224.323 476.746 L -189.559 476.736"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.399759, 0, 0, 0.399759, 492.458771, 134.253098)"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Status Chargedback")), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.19)"
    },
    cx: -257.82,
    cy: 265.405,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 6,
      fill: "rgb(248, 248, 248)",
      stroke: "rgb(137, 75, 0)"
    },
    cx: -252.454,
    cy: 260.025,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 7,
      fill: "rgba(137, 75, 0, 0.31)"
    },
    cx: -251.454,
    cy: 260.025,
    rx: 30.75,
    ry: 30.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(90, 60, 0)"
    },
    d: "M -281.854 269.834 C -281.854 269.834 -283.485 265.214 -274.612 259.83 C -265.737 254.445 -256.923 249.202 -256.923 249.202 C -256.923 249.202 -253.17 246.734 -246.15 243.96 C -239.13 241.188 -223.553 236.887 -223.553 236.887 L -223.382 257.414 L -259.432 277.078 L -281.854 269.834 Z",
    transform: "matrix(0.999901, 0.014077, -0.014077, 0.999901, 3.592476, 3.582367)"
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "Carteira fundo"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.185959, -0.989366, 0.989366, 1.185959, -282.462311, 258.236542)",
    style: {}
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null, "Cash")), /*#__PURE__*/React.createElement("rect", {
    x: 8.919,
    y: 6.811,
    width: 23.773,
    height: 13.849,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(237, 245, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.835 6.276 C 9.013 6.276 8.335 6.954 8.335 7.776 L 8.335 19.776 C 8.335 20.598 9.013 21.276 9.835 21.276 L 31.835 21.276 C 32.657 21.276 33.335 20.598 33.335 19.776 L 33.335 7.776 C 33.335 6.954 32.657 6.276 31.835 6.276 L 9.835 6.276 Z M 9.835 7.276 L 31.835 7.276 C 32.121 7.276 32.335 7.49 32.335 7.776 L 32.335 19.776 C 32.335 20.062 32.121 20.276 31.835 20.276 L 9.835 20.276 C 9.549 20.276 9.335 20.062 9.335 19.776 L 9.335 7.776 C 9.335 7.49 9.549 7.276 9.835 7.276 Z M 10.835 8.276 C 10.559 8.276 10.335 8.5 10.335 8.776 L 10.335 10.776 C 10.335 11.448 11.335 11.432 11.335 10.776 L 11.335 9.276 L 12.835 9.276 C 13.507 9.276 13.491 8.276 12.835 8.276 L 10.835 8.276 Z M 20.835 8.276 C 17.803 8.276 15.335 10.744 15.335 13.776 C 15.335 16.808 17.803 19.276 20.835 19.276 C 23.867 19.276 26.335 16.808 26.335 13.776 C 26.335 10.744 23.867 8.276 20.835 8.276 Z M 28.835 8.276 C 28.179 8.276 28.163 9.276 28.835 9.276 L 30.335 9.276 L 30.335 10.776 C 30.335 11.432 31.335 11.448 31.335 10.776 L 31.335 8.776 C 31.335 8.5 31.111 8.276 30.835 8.276 L 28.835 8.276 Z M 20.835 9.276 C 23.325 9.276 25.335 11.286 25.335 13.776 C 25.335 16.266 23.325 18.276 20.835 18.276 C 18.345 18.276 16.335 16.266 16.335 13.776 C 16.335 11.286 18.345 9.276 20.835 9.276 Z M 20.835 10.276 C 20.558 10.276 20.335 10.499 20.335 10.776 L 20.335 11.37 C 19.757 11.58 19.335 12.13 19.335 12.776 C 19.335 13.596 20.015 14.276 20.835 14.276 C 21.115 14.276 21.335 14.488 21.335 14.776 C 21.335 15.064 21.115 15.276 20.835 15.276 L 19.835 15.276 C 19.497 15.271 19.335 15.524 19.335 15.776 C 19.335 16.028 19.497 16.281 19.835 16.276 L 20.335 16.276 L 20.335 16.776 C 20.335 17.053 20.558 17.276 20.835 17.276 C 21.112 17.276 21.335 17.053 21.335 16.776 L 21.335 16.182 C 21.913 15.972 22.335 15.422 22.335 14.776 C 22.335 13.956 21.655 13.276 20.835 13.276 C 20.555 13.276 20.335 13.064 20.335 12.776 C 20.335 12.488 20.555 12.276 20.835 12.276 L 21.835 12.276 C 22.173 12.281 22.335 12.028 22.335 11.776 C 22.335 11.524 22.173 11.271 21.835 11.276 L 21.335 11.276 L 21.335 10.776 C 21.335 10.499 21.112 10.276 20.835 10.276 Z M 10.835 16.278 C 10.585 16.276 10.335 16.44 10.335 16.776 L 10.335 18.776 C 10.335 19.052 10.559 19.276 10.835 19.276 L 12.835 19.276 C 13.491 19.276 13.507 18.276 12.835 18.276 L 11.335 18.276 L 11.335 16.776 C 11.335 16.448 11.085 16.28 10.835 16.278 Z M 30.835 16.278 C 30.585 16.28 30.335 16.448 30.335 16.776 L 30.335 18.276 L 28.835 18.276 C 28.163 18.276 28.179 19.276 28.835 19.276 L 30.835 19.276 C 31.111 19.276 31.335 19.052 31.335 18.776 L 31.335 16.776 C 31.335 16.44 31.085 16.276 30.835 16.278 Z",
    style: {
      fill: "rgb(58, 128, 14)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.185959, -0.989366, 0.989366, 1.185959, -286.682068, 257.556946)",
    style: {}
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null, "Cash")), /*#__PURE__*/React.createElement("rect", {
    x: 8.919,
    y: 6.811,
    width: 23.773,
    height: 13.849,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(237, 245, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.835 6.276 C 9.013 6.276 8.335 6.954 8.335 7.776 L 8.335 19.776 C 8.335 20.598 9.013 21.276 9.835 21.276 L 31.835 21.276 C 32.657 21.276 33.335 20.598 33.335 19.776 L 33.335 7.776 C 33.335 6.954 32.657 6.276 31.835 6.276 L 9.835 6.276 Z M 9.835 7.276 L 31.835 7.276 C 32.121 7.276 32.335 7.49 32.335 7.776 L 32.335 19.776 C 32.335 20.062 32.121 20.276 31.835 20.276 L 9.835 20.276 C 9.549 20.276 9.335 20.062 9.335 19.776 L 9.335 7.776 C 9.335 7.49 9.549 7.276 9.835 7.276 Z M 10.835 8.276 C 10.559 8.276 10.335 8.5 10.335 8.776 L 10.335 10.776 C 10.335 11.448 11.335 11.432 11.335 10.776 L 11.335 9.276 L 12.835 9.276 C 13.507 9.276 13.491 8.276 12.835 8.276 L 10.835 8.276 Z M 20.835 8.276 C 17.803 8.276 15.335 10.744 15.335 13.776 C 15.335 16.808 17.803 19.276 20.835 19.276 C 23.867 19.276 26.335 16.808 26.335 13.776 C 26.335 10.744 23.867 8.276 20.835 8.276 Z M 28.835 8.276 C 28.179 8.276 28.163 9.276 28.835 9.276 L 30.335 9.276 L 30.335 10.776 C 30.335 11.432 31.335 11.448 31.335 10.776 L 31.335 8.776 C 31.335 8.5 31.111 8.276 30.835 8.276 L 28.835 8.276 Z M 20.835 9.276 C 23.325 9.276 25.335 11.286 25.335 13.776 C 25.335 16.266 23.325 18.276 20.835 18.276 C 18.345 18.276 16.335 16.266 16.335 13.776 C 16.335 11.286 18.345 9.276 20.835 9.276 Z M 20.835 10.276 C 20.558 10.276 20.335 10.499 20.335 10.776 L 20.335 11.37 C 19.757 11.58 19.335 12.13 19.335 12.776 C 19.335 13.596 20.015 14.276 20.835 14.276 C 21.115 14.276 21.335 14.488 21.335 14.776 C 21.335 15.064 21.115 15.276 20.835 15.276 L 19.835 15.276 C 19.497 15.271 19.335 15.524 19.335 15.776 C 19.335 16.028 19.497 16.281 19.835 16.276 L 20.335 16.276 L 20.335 16.776 C 20.335 17.053 20.558 17.276 20.835 17.276 C 21.112 17.276 21.335 17.053 21.335 16.776 L 21.335 16.182 C 21.913 15.972 22.335 15.422 22.335 14.776 C 22.335 13.956 21.655 13.276 20.835 13.276 C 20.555 13.276 20.335 13.064 20.335 12.776 C 20.335 12.488 20.555 12.276 20.835 12.276 L 21.835 12.276 C 22.173 12.281 22.335 12.028 22.335 11.776 C 22.335 11.524 22.173 11.271 21.835 11.276 L 21.335 11.276 L 21.335 10.776 C 21.335 10.499 21.112 10.276 20.835 10.276 Z M 10.835 16.278 C 10.585 16.276 10.335 16.44 10.335 16.776 L 10.335 18.776 C 10.335 19.052 10.559 19.276 10.835 19.276 L 12.835 19.276 C 13.491 19.276 13.507 18.276 12.835 18.276 L 11.335 18.276 L 11.335 16.776 C 11.335 16.448 11.085 16.28 10.835 16.278 Z M 30.835 16.278 C 30.585 16.28 30.335 16.448 30.335 16.776 L 30.335 18.276 L 28.835 18.276 C 28.163 18.276 28.179 19.276 28.835 19.276 L 30.835 19.276 C 31.111 19.276 31.335 19.052 31.335 18.776 L 31.335 16.776 C 31.335 16.44 31.085 16.276 30.835 16.278 Z",
    style: {
      fill: "rgb(58, 128, 14)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.185959, -0.989366, 0.989366, 1.185959, -291.813782, 257.1633)",
    style: {}
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", null, "Cash")), /*#__PURE__*/React.createElement("rect", {
    x: 8.919,
    y: 6.811,
    width: 23.773,
    height: 13.849,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(237, 245, 199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.835 6.276 C 9.013 6.276 8.335 6.954 8.335 7.776 L 8.335 19.776 C 8.335 20.598 9.013 21.276 9.835 21.276 L 31.835 21.276 C 32.657 21.276 33.335 20.598 33.335 19.776 L 33.335 7.776 C 33.335 6.954 32.657 6.276 31.835 6.276 L 9.835 6.276 Z M 9.835 7.276 L 31.835 7.276 C 32.121 7.276 32.335 7.49 32.335 7.776 L 32.335 19.776 C 32.335 20.062 32.121 20.276 31.835 20.276 L 9.835 20.276 C 9.549 20.276 9.335 20.062 9.335 19.776 L 9.335 7.776 C 9.335 7.49 9.549 7.276 9.835 7.276 Z M 10.835 8.276 C 10.559 8.276 10.335 8.5 10.335 8.776 L 10.335 10.776 C 10.335 11.448 11.335 11.432 11.335 10.776 L 11.335 9.276 L 12.835 9.276 C 13.507 9.276 13.491 8.276 12.835 8.276 L 10.835 8.276 Z M 20.835 8.276 C 17.803 8.276 15.335 10.744 15.335 13.776 C 15.335 16.808 17.803 19.276 20.835 19.276 C 23.867 19.276 26.335 16.808 26.335 13.776 C 26.335 10.744 23.867 8.276 20.835 8.276 Z M 28.835 8.276 C 28.179 8.276 28.163 9.276 28.835 9.276 L 30.335 9.276 L 30.335 10.776 C 30.335 11.432 31.335 11.448 31.335 10.776 L 31.335 8.776 C 31.335 8.5 31.111 8.276 30.835 8.276 L 28.835 8.276 Z M 20.835 9.276 C 23.325 9.276 25.335 11.286 25.335 13.776 C 25.335 16.266 23.325 18.276 20.835 18.276 C 18.345 18.276 16.335 16.266 16.335 13.776 C 16.335 11.286 18.345 9.276 20.835 9.276 Z M 20.835 10.276 C 20.558 10.276 20.335 10.499 20.335 10.776 L 20.335 11.37 C 19.757 11.58 19.335 12.13 19.335 12.776 C 19.335 13.596 20.015 14.276 20.835 14.276 C 21.115 14.276 21.335 14.488 21.335 14.776 C 21.335 15.064 21.115 15.276 20.835 15.276 L 19.835 15.276 C 19.497 15.271 19.335 15.524 19.335 15.776 C 19.335 16.028 19.497 16.281 19.835 16.276 L 20.335 16.276 L 20.335 16.776 C 20.335 17.053 20.558 17.276 20.835 17.276 C 21.112 17.276 21.335 17.053 21.335 16.776 L 21.335 16.182 C 21.913 15.972 22.335 15.422 22.335 14.776 C 22.335 13.956 21.655 13.276 20.835 13.276 C 20.555 13.276 20.335 13.064 20.335 12.776 C 20.335 12.488 20.555 12.276 20.835 12.276 L 21.835 12.276 C 22.173 12.281 22.335 12.028 22.335 11.776 C 22.335 11.524 22.173 11.271 21.835 11.276 L 21.335 11.276 L 21.335 10.776 C 21.335 10.499 21.112 10.276 20.835 10.276 Z M 10.835 16.278 C 10.585 16.276 10.335 16.44 10.335 16.776 L 10.335 18.776 C 10.335 19.052 10.559 19.276 10.835 19.276 L 12.835 19.276 C 13.491 19.276 13.507 18.276 12.835 18.276 L 11.335 18.276 L 11.335 16.776 C 11.335 16.448 11.085 16.28 10.835 16.278 Z M 30.835 16.278 C 30.585 16.28 30.335 16.448 30.335 16.776 L 30.335 18.276 L 28.835 18.276 C 28.163 18.276 28.179 19.276 28.835 19.276 L 30.835 19.276 C 31.111 19.276 31.335 19.052 31.335 18.776 L 31.335 16.776 C 31.335 16.44 31.085 16.276 30.835 16.278 Z",
    style: {
      fill: "rgb(58, 128, 14)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(137, 75, 0)",
      fill: "url(#gradient-0)"
    },
    d: "M -278.365 264.556 L -250.331 260.031 C -250.331 260.031 -245.049 259.526 -241.906 256.259 C -238.765 252.991 -224.934 237.274 -224.934 237.274 C -224.934 237.274 -220.784 235.515 -220.661 239.663 C -220.535 243.811 -220.784 261.665 -220.784 261.665 C -220.784 261.665 -221.413 266.19 -225.059 269.46 C -228.705 272.729 -239.713 281.25 -239.713 281.25 C -239.713 281.25 -243.358 283.137 -248.01 283.892 C -252.663 284.645 -276.047 288.039 -276.047 288.039 C -276.047 288.039 -279.316 287.787 -279.565 284.393 C -279.817 280.997 -281.759 269.207 -281.759 269.207 C -281.759 269.207 -281.759 265.814 -278.365 264.556 Z",
    transform: "matrix(0.999901, 0.014077, -0.014077, 0.999901, 3.669888, 3.56201)"
  }, _title7 || (_title7 = /*#__PURE__*/React.createElement("title", null, "Carteira frente")))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardStatusChargedback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-status-chargedback.531d5ae425da24c65a41ef7a5999fb2e.svg";